import axios from '../../../utilities/axios';
import {AnswerRequest} from '../../../models/requests/answer.request';
import {AnswerDto} from '../../../models/dtos/answer.dto';

export const answerRequest = async (request: AnswerRequest): Promise<AnswerDto> => {
  try {
    const response = await axios.post<AnswerDto>(
      `${process.env.REACT_APP_BASE_URL}/answers`,
      {...request},
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
